export default "__VITE_ASSET__ToixIxgF__"